module.exports = __webpack_public_path__ + "img/user-4.27a3d858.jpg";